export const GTM_CONTAINER_ID =
  (import.meta.env.VITE_GTM_CONTAINER_ID as string | undefined) || "GTM-NCX2CL4N";

export function pushGtmPageView(pathname: string, search = "") {
  const pagePath = `${pathname}${search}`;
  const dataLayer = (window.dataLayer ??= []);
  dataLayer.push({
    event: "virtual_page_view",
    page_path: pagePath,
    page_title: document.title,
    page_location: `${window.location.origin}${pagePath}`,
  });
}
